import type { FC, ReactNode } from 'react'

const TICKS = 'repeating-linear-gradient(to bottom, #d3dadd 0 1px, transparent 1px 72px)'
const FINE_TICKS = 'repeating-linear-gradient(to bottom, #e3e8ea 0 1px, transparent 1px 18px)'

/** Fixed engineering-drawing rails along both page edges, sitting behind all content. */
const BlueprintGrid: FC = (): ReactNode => {
    return (
        <div aria-hidden='true' className='pointer-events-none fixed inset-0 -z-10'>
            <div className='absolute inset-y-0 left-3 w-px bg-line md:left-5' />
            <div className='absolute inset-y-0 right-3 w-px bg-line md:right-5' />

            <div className='absolute inset-y-0 left-3 hidden w-2 md:left-5 md:block' style={{ backgroundImage: FINE_TICKS }} />
            <div className='absolute inset-y-0 left-3 hidden w-3.5 md:left-5 md:block' style={{ backgroundImage: TICKS }} />
            <div className='absolute inset-y-0 right-3 hidden w-2 md:right-5 md:block' style={{ backgroundImage: FINE_TICKS }} />
            <div className='absolute inset-y-0 right-3 hidden w-3.5 md:right-5 md:block' style={{ backgroundImage: TICKS }} />
        </div>
    )
}

export default BlueprintGrid
